import type { JSX } from 'react';
import { Chip } from '@heroui/react';

import type { OrgRole } from '~/types';

interface RoleBadgeProps {
  role: OrgRole;
  size?: 'sm' | 'md' | 'lg';
}

const roleClassName = {
  admin: 'bg-role-admin text-foreground',
  member: '',
  owner: 'bg-role-owner text-foreground',
} as const;

export function RoleBadge({ role, size = 'sm' }: RoleBadgeProps): JSX.Element {
  return (
    <Chip className={`capitalize ${roleClassName[role]}`} size={size}>
      {role}
    </Chip>
  );
}
